<template>
  <div class="custom-ui-editor-wrapper">
    <span class="custom-ui-editor-label" v-text="label" />
    <ckeditor v-model="model" :config="editorConfig" :editor="ClassicEditor" :disabled="disabled" />
  </div>
</template>

<script setup lang="ts">
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import { Ckeditor } from '@ckeditor/ckeditor5-vue'
  import { ref, watch } from 'vue'

  const { label = '', disabled = false } = defineProps({
    label: String,
    disabled: Boolean,
  })

  const model = defineModel({ required: true, type: String })

  const editorConfig = ref({
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote',
      'insertTable',
      'undo',
      'redo',
      'indent',
      'outdent',
    ],
    link: {
      addTargetToExternalLinks: true,
    },
  })

  watch(model, val => {
    if (val.includes('<img')) {
      model.value = val.replace(/<img[^>]*>/g, '')
    }
    if (val.includes('<video')) {
      model.value = val.replace(/<video[^>]*>/g, '')
    }
    if (val.includes('<audio')) {
      model.value = val.replace(/<audio[^>]*>/g, '')
    }
  })
</script>

<style lang="scss">
  .custom-ui-editor-wrapper {
    @include flexible($direction: column);
    width: 100%;
    .custom-ui-editor-label {
      @include column-label;
    }
    .ck-editor__editable {
      min-height: 150px !important;
    }
    .ck.ck-editor {
      width: 100% !important;
    }
  }
</style>
